<template>
	<div class="inner-page doc-library">
		<AppHead title="Document Library" />

		<PageHeader 
      title="Document Library"
      desc="Documents which are available for you to download"
      :hasButton="false"
      :showHelper="true"
      helpTitle="Welcome to your Document Library"
      helpDesc="You may download any documents in here. You will find useful documents under 'General Documents' which you can download at will."
      />

    <DocLibraryControls
      v-if="$page.props.user.user_type == 'admin'"
      @done="refreshFiles"
      />

    <TableDocuments
      noDocsMessage="There are no documents available"
      :files="globalFiles"
      :showProcessing="['admin'].includes($page.props.user.user_type)"
      :canDelete="['admin'].includes($page.props.user.user_type)"
      />
    
	</div>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout.vue"
import AppHead from "@/Components/AppHead"
import PageHeader from "@/Components/PageHeader"
import TableDocuments from "@/Components/TableDocuments"
import DocLibraryControls from "@/Components/Admin/DocLibraryControls"

export default {
	components: {
		AppLayout,
    AppHead,
    PageHeader,
    TableDocuments,
    DocLibraryControls
	},
  props: {
    globalFiles: Array
  },
  mounted(){
    
  },
  methods: {
    refreshFiles(){
      this.$inertia.reload()
    }
  },
	layout: AppLayout
};
</script>

<style lang="sass">

// .doc-library

</style>